import { Schema, z } from 'zod';
import { DefinitionStatusType, DefinitionStatusSchema } from './schema';

export type ModuleRestriction = {
  readonly name: string;
  readonly version: string;
};

export type ZoneValidation = {
  readonly isInheritable?: boolean;
  readonly moduleRestrictions?: ReadonlyArray<ModuleRestriction>;
};

export const ZoneValidationSchema: Schema<ZoneValidation> = z.object({
  isInheritable: z.boolean().optional(),
  moduleRestrictions: z
    .array(
      z.object({
        name: z.string(),
        version: z.string()
      })
    )
    .optional()
});

/**
 * Zones are different sections of a surface.
 * @property - label - a human readable name.
 * @property - description - a human readable description.
 * @property - status - represents whether new surface definitions are allowed to use this zone definition.
 * @property - validations - an optional object for defining rules about how a zones behave both during Surface instantiation and in Module selection.
 */

export type ZoneDefinition = {
  readonly name: string;
  readonly label: string;
  readonly description: string;
  readonly status: DefinitionStatusType;
  readonly validations?: ZoneValidation;
};
export const ZoneDefinitionSchema: Schema<ZoneDefinition> = z.object({
  name: z.string(),
  label: z.string(),
  description: z.string(),
  status: DefinitionStatusSchema,
  validations: ZoneValidationSchema.optional()
});
